import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DeviceDependentElement from 'components/DeviceDependentElement';
import { DateTimePicker } from 'react-widgets';
import Moment from 'moment';
import momentLocalizer from 'react-widgets-moment';

class DateField extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    inputProps: PropTypes.object,
    meta: PropTypes.object,
    error: PropTypes.string,
    className: PropTypes.string,
  }

  state = {
    open: false,
  }

  handleInputClick = (event) => {
    if (event.target.tagName === 'INPUT') {
      this.open(true);
    }
  }

  handleToggle = (view) => {
    this.open(!this.state.open, view);
  }

  open(shouldOpen, view = null) {
    if (!view) {
      view = 'date';
    }
    const toggledState = shouldOpen ? view : false;
    this.setState({ open: toggledState });
  }

  componentDidMount() {
    Moment.locale('en');
  }

  onChange = (e) => {
    const currentValue = Moment(e);
    this.props.input.onChange(currentValue.format('YYYY-MM-DD'));
  }

  render() {
    const { input, inputProps } = this.props;
    momentLocalizer();

    let currentValue = null;
    if (input.value && input.value != 'Invalid date') {
      currentValue = Moment(input.value).toDate();
    }

    inputProps.format = 'D MMM YYYY';
    inputProps.parse = [
      'D MMM YYYY',
      'L',
      'l'
    ];

    return (
      <div className={`DynamicDatePicker ${this.props.className}`}>
        <DeviceDependentElement desktop>
          <DateTimePicker
            onChange={this.onChange}
            onBlur={() => input.onBlur(input.value)}
            onClick={this.handleInputClick}
            onToggle={this.handleToggle}
            open={this.state.open}
            value={currentValue}
            min={new Date()}
            name={input.name}
            {...inputProps}
          />
        </DeviceDependentElement>
        <DeviceDependentElement mobile>
          <input
            type="date"
            value={input.value}
            onChange={input.onChange}
            onBlur={() => input.onBlur(input.value)}
            className="form-control"
            min={Moment().format()}
            name={input.name}
            {...inputProps}
          />
        </DeviceDependentElement>
      </div>
    );
  }
}

const wrapper = (props, error, componentProps) => (
  <DateField {...props} className={componentProps.className}/>
);

export default wrapper;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/DateField.jsx